import Home from "@/views/HomePage.vue";
import About from "@/views/AboutPage.vue";
import ForOrganizers from "@/views/ForOrganizersPage.vue";
import AdminLayout from "@/views/admin/AdminLayout.vue";
import AdminMyEvents from "@/views/admin/AdminMyEvents.vue";
import AdminConcerts from "@/views/admin/AdminConcerts.vue";
import AdminExternalEvents from "@/views/admin/AdminExternalEvents.vue";
import AdminUsers from "@/views/admin/AdminUsers.vue";
import AdminAnalytics from "@/views/admin/AdminAnalytics.vue";
import Login from "@/views/Login.vue";
import Register from "@/views/Register.vue";
import AuthCallback from "@/views/AuthCallback.vue";
import MyFavorites from "@/views/MyFavorites.vue";
import PolicyPage from "@/views/PolicyPage.vue";
import MerchPage from "@/views/MerchPage.vue";
import MerchThanks from "@/views/MerchThanks.vue";
import { isLoggedIn, isSuperAdmin, isOrganizer } from "@/utils/auth.js";

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    // Delbar/indexerbar URL per event. Renderas av samma HomePage-instans
    // som "/" (Vue Router återanvänder komponenten) — sluggen i URL:en styr
    // event-panelen via en route-watcher i HomePage. Direktbesök öppnar
    // panelen ovanpå listan; bakåtknappen stänger den.
    path: "/event/:slug",
    name: "concert",
    component: Home,
  },
  {
    path: "/about",
    name: "about",
    component: About,
  },
  {
    path: "/for-organizers",
    name: "for-organizers",
    component: ForOrganizers,
  },
  {
    path: "/favoriter",
    name: "favorites",
    component: MyFavorites,
    beforeEnter: (to, from, next) => {
      if (!isLoggedIn.value) return next("/login");
      next();
    },
  },
  {
    path: "/admin",
    component: AdminLayout,
    beforeEnter: (to, from, next) => {
      if (!isLoggedIn.value) return next("/login");
      // Endast organizer eller super-admin har åtkomst till admin
      if (!isOrganizer.value && !isSuperAdmin.value) return next("/");
      next();
    },
    children: [
      {
        path: "",
        redirect: () =>
          isSuperAdmin.value ? "/admin/concerts" : "/admin/my-events",
      },
      {
        path: "my-events",
        name: "admin-my-events",
        component: AdminMyEvents,
        beforeEnter: (to, from, next) => {
          // Endast organizer:er ska kunna nå sin "Mina event"-vy. Super-
          // admin har ingen venue - skicka dem till sin konsert-översikt.
          if (!isOrganizer.value) {
            return next(isSuperAdmin.value ? "/admin/concerts" : "/");
          }
          next();
        },
      },
      {
        path: "concerts",
        name: "admin-concerts",
        component: AdminConcerts,
        beforeEnter: (to, from, next) => {
          if (!isSuperAdmin.value) return next("/admin/my-events");
          next();
        },
      },
      {
        path: "external-events",
        name: "admin-external-events",
        component: AdminExternalEvents,
        beforeEnter: (to, from, next) => {
          if (!isSuperAdmin.value) return next("/admin/my-events");
          next();
        },
      },
      {
        path: "users",
        name: "admin-users",
        component: AdminUsers,
        beforeEnter: (to, from, next) => {
          if (!isSuperAdmin.value) return next("/admin/my-events");
          next();
        },
      },
      {
        path: "analytics",
        name: "admin-analytics",
        component: AdminAnalytics,
        beforeEnter: (to, from, next) => {
          if (!isSuperAdmin.value) return next("/admin/my-events");
          next();
        },
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/register",
    name: "register",
    component: Register,
  },
  {
    path: "/auth-callback",
    name: "auth-callback",
    component: AuthCallback,
  },
  {
    path: "/policy",
    name: "policy",
    component: PolicyPage,
  },
  {
    path: "/merch",
    name: "merch",
    component: MerchPage,
  },
  {
    path: "/merch/tack",
    name: "merch-thanks",
    component: MerchThanks,
  },
];

export default routes;
